import React from "react";
import DragDropVisorPlaceholder from "./DragDropVisorPlaceholder";
import VisorPluginPlaceholder from "../../../_visor/components/canvas/VisorPluginPlaceholder";

import i18n from "i18next";
import { letterFromNumber } from "../../../common/common_tools";
import DragDropVisor from "../DragDropVisor";

/* eslint-disable react/prop-types */

export function DragDrop() {
  return {
    getRenderTemplate: function (state, props) {
      return <DragDropVisor state={state} props={props} />;
    },
    checkAnswer(current, correct) {
      if (!Array.isArray(current) || !Array.isArray(correct)) {
        return false;
      }
      if (current.length !== correct.length) {
        return false;
      }

      let flag = 0;
      for (let i = 0; i < current.length; i++) {
        if (current[i] == correct[i]) {
          flag++;
        }
      }
      return flag == current.length;
    },
  };
}
